import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Cookies from 'universal-cookie';

const cookies = new Cookies();
export default class NavbarGeneral extends Component {

    cerrar_sesion() {

        cookies.remove('id', { path: "/" });
        cookies.remove('nombre', { path: "/" });

        //remover cookies de login
        cookies.remove('log', { path: "/" });
        cookies.remove('rol', { path: "/" });


        cookies.remove('token', { path: "/" });
        cookies.remove('idEstudiante', { path: "/" });
        cookies.remove('idAdministrativo', { path: "/" });

        //remover cookies de la ruta de estudiante
        cookies.remove('nombres', { path: "/" });
        cookies.remove('apellidos', { path: "/" });
        cookies.remove('idCarreraEstu', { path: "/" });
        cookies.remove('idMatriculas', { path: "/" });
        cookies.remove('idperiodoActual', { path: "/" });
        cookies.remove('nomCompleEst', { path: "/" });
        cookies.remove('cedulaEstudiante', { path: "/" });

        window.location.href = "/login";

    }

    toggleSidebar = () => {
        document.body.classList.toggle("sb-sidenav-toggled");
    };

    render() {


        return (

            <nav className="sb-topnav navbar navbar-expand-lg navbar-dark bg-azul shadow-sm px-4">
                <Link to="#" className="navbar-brand fw-bold text-uppercase">
                    <i className="fas fa-desktop me-2"></i> ISTMAS
                </Link>

                <button
                    className="btn btn-link order-1 order-lg-0 text-white"
                    id="sidebarToggle"
                    onClick={this.toggleSidebar}
                >
                    <i className="fas fa-bars"></i>
                </button>

                <ul className="navbar-nav ms-auto">
                    <li className="nav-item dropdown">
                        <a
                            className="nav-link dropdown-toggle d-flex align-items-center"
                            id="userDropdown"
                            href="#"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <i className="fas fa-user-circle fa-lg me-2"></i>
                            <span className="d-none d-md-inline text-white">Mi Cuenta</span>
                        </a>
                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                            <li>
                                <button className="dropdown-item text-secondary" onClick={this.cerrar_sesion}>
                                    <i className="fas fa-sign-out-alt me-2"></i>Salir
                                </button>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>

        )
    }
}